export enum ScreenSize {
	XXSMALL = "(min-width: 414px)",
	XSMALL = "(min-width: 768px)",
	SMALL = "(min-width: 1024px)",
	MEDIUM = "(min-width: 1281px)",
	LARGE = "(min-width: 1440px)",
	XLARGE = "(min-width: 1600px)",
}
